export const ButtonFloatingAddComponent: ng.IComponentOptions = {
  transclude: true,
  templateUrl:
    'components/Buttons/button-floating-add/button-floating-add.html',
};
